const splitLines = (value: string): string[] =>
  value
    .trim()
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean);

export const disposalDepartmentItems = splitLines(`
AGD-Attorney General's Office
AGD-Crown Prosecution Service
AGD-Crown Prosecution Service Inspectorate
AGD-Government Legal Department
AGD-Serious Fraud Office
BEIS-Council for Science and Technology
CC-Charity Commission
CLD-Chancellor's other departments
CLD-Government Actuary's Department
CLD-National Savings and Investments
CMA-Competition and Markets Authority
CO-Advisory Committee on Business Appointments
CO-Boundary Commission for England
CO-Boundary Commission for Wales
CO-Cabinet Office (excl. agencies)
CO-Civil Service Commission
CO-Committee on Standards in Public Life
CO-Crown Commercial Service
CO-Equality and Human Rights Commission
CO-Government Property Agency
CO-House of Lords Appointments Commission
CO-Office of the Leader of the House of Commons
CO-Office of the Leader of the House of Lords
CO-Other Cabinet Office Agencies
CO-Prime Minister's Office
CO-Security Vetting Appeals Panel
CO-Senior Salaries Review Body
DBT-Advisory, Conciliation and Arbitration Service
DBT-British Business Bank
DBT-British Hallmarking Council
DBT-Central Arbitration Committee
DBT-Certification Office
DBT-Companies House
DBT-Competition Appeal Tribunal
DBT-Competition Service
DBT-Financial Reporting Council (ARGA - Audit, Reporting and Governance Authority)
DBT-Groceries Code Adjudicator
DBT-Insolvency Service
DBT-Low Pay Commission
DBT-Regulatory Policy Committee
DBT-Small Business Commissioner
DCMS-Arts Council England
DCMS-BBC
DCMS-Birmingham Organising Committee for 2022 Commonwealth Games Ltd
DCMS-British Film Institute
DCMS-British Library
DCMS-British Museum
DCMS-British Tourist Authority (Visit Britain)
DCMS-Channel 4
DCMS-Churches Conservation Trust
DCMS-Department for Culture, Media and Sport
DCMS-Gambling Commission
DCMS-Geffrye Museum
DCMS-Historic England
DCMS-Historic Royal Palaces
DCMS-Horniman Public Museum and Public Park Trust
DCMS-Horserace Betting Levy Board
DCMS-Imperial War Museum
DCMS-Information Commissioner's Office
DCMS-National Citizen Service
DCMS-National Gallery
DCMS-National Heritage Memorial Fund
DCMS-National Museums Liverpool
DCMS-National Portrait Gallery
DCMS-Natural History Museum
DCMS-OfCOM
DCMS-Phone-paid Services Authority
DCMS-Royal Armouries Museum
DCMS-Royal Museums Greewich
DCMS-S4C
DCMS-Science Museum Group
DCMS-Sir John Soane's Museum
DCMS-Sport England
DCMS-Sports Grounds Safety Authority
DCMS-Tate
DCMS-The Advisory Council on National Records and Archives
DCMS-The Gambling Commission
DCMS-The National Lottery Community Fund
DCMS-The Reviewing Committee on the Export of Works of Art and Objects of Cultural Interest
DCMS-The Theatres Trust
DCMS-Treasure Valuation Committee
DCMS-UK Anti-Doping
DCMS-UK Sport
DCMS-Victoria and Albert Museum
DCMS-Wallace Collection
DEFRA-Advisory Committee on Releases to the Environment
DEFRA-Agriculture and Horticulture Development Board
DEFRA-Animal and Plant Health Agency
DEFRA-Board of Trustees of the Royal Botanic Gardens Kew
DEFRA-CCW
DEFRA-Centre for Environment, Fisheries and Aquaculture Science
DEFRA-CGMA
DEFRA-Consumer Council for Water
DEFRA-Department for Environment, Food and Rural Affairs (excl. agencies)
DEFRA-Environment Agency
DEFRA-Forestry Commission
DEFRA-Independent Agricultural Appeals Panel
DEFRA-Joint Nature Conservation Committee
DEFRA-Marine Management Organisation
DEFRA-Natural England
DEFRA-Office for Environmental Protection
DEFRA-Plant Varieties and Seeds Tribunal
DEFRA-Royal Botanic Gardens, Kew
DEFRA-Rural Payments Agency
DEFRA-Science Advisory Council
DEFRA-Veterinary Medicines Directorate
DESNZ-Civil Nuclear Police Authority
DESNZ-Mining Remediation Authority
DESNZ-Committee on Climate Change
DESNZ-North Sea Transition Authority
DESNZ-Nuclear Decommissioning Authority
DESNZ-Salix
DESNZ-United Kingdom Atomic Energy Authority
DFE-Construction Industry Training Board
DFE-Department for Education (excl. agencies)
DFE-Education and Skills Funding Agency
DFE-Engineering Construction Industry Training Board (CITB)
DFE-Institute for Apprenticeships and Technical Education
DFE-LocatED
DFE-Office for Students (OfS)
DFE-Office of the Children's Commissioner (OCC)
DFE-Social Mobility Commission
DFE-Standards and Testing Agency
DFE-Student Loans Company
DFE-Teaching Regulation Agency
DFT-British Transport Police Authority
DFT-Civil Aviation Authority
DFT-Department for Transport (excl. agencies)
DFT-Driver and Vehicle Licensing Agency
DFT-Driver and Vehicle Standards Agency
DFT-East West Railway Company
DFT-High Speed 2 Ltd
DFT-London Continental Railway
DFT-Maritime and Coastguard Agency
DFT-National Highways
DFT-Network Rail
DFT-Traffic Commissioners
DFT-Transport Focus
DFT-Vehicle Certification Agency
DHSC-Advisory Committee on Animal Feeding stuffs
DHSC-Advisory Committee on Novel Foods and Processes
DHSC-Advisory Committee on the Microbiological Safety of Food
DHSC-Committee on Toxicity of Chemicals in Food, Consumer Products and the Environment
DHSC-Community Health Partnerships
DHSC-Department of Health and Social Care (excl. agencies)
DHSC-General Advisory Committee on Science/Science Council
DHSC-Genomics England
DHSC-Health Education England
DHSC-Health Research Authority
DHSC-Human Fertilisation and Embryology Authority (HFEA)
DHSC-Human Tissue Authority
DHSC-Independent Reconfiguration Panel
DHSC-Medicines and Healthcare Products Regulatory Agency
DHSC-National Institute for Health and Care Excellence (NICE)
DHSC-NGO
DHSC-NHS Blood and Transplant
DHSC-NHS Care Quality Commission
DHSC-NHS Counter Fraud Authority
DHSC-NHS Digital
DHSC-NHS England and NHS Improvement
DHSC-NHS Property Services
DHSC-NHS Resolution
DHSC-NHS Trust/ Foundation Trusts
DHSC-Nursing and Midwifery Council
DHSC-Public Health England
DHSC-Social Science Research Committee
DHSC-UK Health Security Agency (former PHE)
DIT-Department for International Trade
DIT-UK Trade Remedies Authority
MHCLG-Architects Registration Board
MHCLG-Ministry of Housing, Communities and Local Government (excl. agencies)
MHCLG-Ebbsfleet Development Corporation
MHCLG-Homes England
MHCLG-LGO
MHCLG-Local Government & Social Care Ombudsman
MHCLG-Planning Inspectorate
MHCLG-Queen Elizabeth II Centre
MHCLG-Regulator of Social Housing
MHCLG-The Housing Ombudsman
MHCLG-The Leasehold Advisory Service
MHCLG-Valuation Tribunal Service
DSIT-Advanced Research and Invention Agency
DSIT-Biotechnology and Biological Sciences Research Council
DSIT-Economic and Social Research Council
DSIT-Engineering and Physical Sciences Research Council
DSIT-Government Office for Science
DSIT-Innovate UK
DSIT-Intellectual Property Office
DSIT-Medical Research Council (MRC)
DSIT-Met Office
DSIT-Ordnance Survey
DSIT-UK Intellectual Property Office
DSIT-UK Research and Innovation
DSIT-UK Space Agency
DWP-BPDTS Ltd
DWP-Department for Work and Pensions (excl. agencies)
DWP-Disabled People's Employment Corporation
DWP-Health and Safety Executive
DWP-Industrial Injuries Advisory Council
DWP-Money & Pensions Service
DWP-National Employment Savings Trust (NEST) Corporation
DWP-Office for Nuclear Regulation
DWP-Pensions Ombudsman
DWP-Pensions Regulator
DWP-Remploy Pension Scheme
DWP-Social Security Advisory Committee
DWP-The Pensions Protection Fund
ESTYN-ESTYN
FCDO-BBC World Service
FCDO-British Council
FCDO-Commonwealth Scholarship Commission (CSC)
FCDO-FCDO Services
FCDO-Foreign, Commonwealth and Development Office (excl. agencies)
FCDO-Great Britain China Centre
FCDO-Her Majesty's Government Communications Centre
FCDO-Independent Commission for Aid Impact (ICAI)
FCDO-Stabilisation Unit
FCDO-UK-India Round Table
FCDO-Westminster Foundation for Democracy
FCDO-Wilton Park
FSA-Food Standards Agency
HMLR-HM Land Registry
HMRC-HM Revenue and Customs (excl. agencies)
HMRC-Valuation Office Agency
HMT-Debt Management Office
HMT-Financial Services Compensation Scheme
HMT-Government Internal Audit Agency
HMT-HM Treasury (excl. agencies)
HMT-National Infrastructure Bank
HMT-National Infrastructure Commission
HMT-Office for Budget Responsibility
HMT-Reclaim Fund Ltd
HMT-Royal Household Sovereign Grant
HMT-Royal Mint Advisory Committee
HMT-UK Debt Management Office
HMT-UK Government Investments Ltd
HMT-Various funds (Consolidated Fund, Contingencies Fund, National Loans Fund, Exchange Equalisation Account)
HO-Advisory Council on the Misuse of Drugs (ACMD)
HO-Animals in Science Committee (ASC)
HO-College of Policing
HO-Disclosure and Barring Service
HO-Gangmaster and Labour Abuse Authority
HO-Home Office (incl. agencies)
HO-Independent Office of Police Conduct
HO-Investigatory Powers Tribunal
HO-Migration Advisory Committee
HO-National Crime Agency Remuneration Review Body
HO-Office of the Immigration Services Commissioner
HO-Security Industry Authority
MOD-Armed Forces Pay Review Body
MOD-Defence Electronics & Components Agency
MOD-Defence Equipment and Support
MOD-Defence Nuclear Safety Committee
MOD-Defence Science and Technology Laboratory
MOD-Defence Scientific Advisory Council
MOD-Independent Monitoring Board for the Military Corrective Training Centre
MOD-Ministry of Defence (excl. agencies)
MOD-National Army Museum
MOD-National Museum of the Royal Navy
MOD-Nuclear Research Advisory Council
MOD-Royal Air Force Museum
MOD-Royal Fleet Auxiliary
MOD-Service Complaints Ombudsman
MOD-Single Source Regulations Office
MOD-SSRO
MOD-Submarine Delivery Agency
MOD-The Oil Pipeline Agency
MOD-UK Hydrographic Office
MOJ-Children and Family Court Advisory and Support Service
MOJ-Criminal Cases Review Commission
MOJ-Criminal Injuries Compensation Authority
MOJ-Gov Facility Services Limited
MOJ-Her Majesty's Courts and Tribunals Service
MOJ-Her Majesty's Prison and Probation Service
MOJ-HMI Prisons
MOJ-HMI Probation
MOJ-Independent Monitoring Authority for the Citizen's rights
MOJ-Independent Monitoring Boards and Lay Observers
MOJ-Judicial Appointments and Conduct Ombudsman
MOJ-Judicial Appointments Commission
MOJ-Judicial Office
MOJ-Law Commission
MOJ-Legal Aid Agency
MOJ-Legal Services Board
MOJ-Ministry of Justice (excl. agencies)
MOJ-Office for Legal Complaints (Legal Ombudsman)
MOJ-Office of the Public Guardian
MOJ-Official Solicitor and Public Trustee
MOJ-Parole Board
MOJ-Prisons and Probation Ombudsman
MOJ-Sentencing Council
MOJ-Victims' Commissioner
MOJ-Youth Justice Board
NA-The National Archives
NCA-National Crime Agency
NIO-Northern Ireland Office
OFGEM-Office of Gas and Electricity Markets
OFQUAL-Office of Qualifications and Examinations Regulation
OFSTED-Office for Standards in Education, Children's Services and Skills
OFWAT-Water Services Regulation
OFWAT-Water Services Regulation Authority
ORR-Office of Rail and Road
Other-Commonwealth Parliamentary Association UK
Other-Cross Departmental Opportunities
Other-Disclosure & Barring Service
Other-Forestry Commission - Forest Research
Other-Forestry Commission Central Services
Other-Forestry Commission England
Other-GCHQ
Other-Government Commercial Function
Other-Government Communication Service
Other-Government Communications Headquarters
Other-Government Digital Service
Other-Government Economic Service & Social Research Profession
Other-Government Operational Research Service
Other-Government Project Delivery Profession
Other-Government Statistical Service
Other-Her Majesty's Inspectorate of Constabulary and Fire & Rescue Services
Other-Human Fertilisation & Embryology Authority
Other-Independent Inquiry into Child Sexual Abuse
Other-Independent Parliamentary Standards Authority
Other-Meteorological Office
Other-MI5
Other-MI6 - Secret Intelligence Service
Other-Office of Tax Simplification
Other-Parliamentary and Health Service Ombudsman
Other-Parliamentary Works Sponsor Body
Other-Research England
SG-Accountant in Bankruptcy
SG-Crown Office and Procurator Fiscal Service
SG-Disclosure Scotland
SG-Education Scotland
SG-Food Standards Scotland
SG-Forestry and Land Scotland
SG-Historic Environment Scotland
SG-National Records of Scotland
SG-Office of the Scottish Charity Regulator
SG-Registers of Scotland
SG-Revenue Scotland
SG-Scottish Courts and Tribunals Service
SG-Scottish Fiscal Commission
SG-Scottish Forestry
SG-Scottish Further and Higher Education Funding Council
SG-Scottish Government (excl. agencies)
SG-Scottish Housing Regulator
SG-Scottish Prison Service
SG-Scottish Public Pensions Agency
SG-Social Security Scotland
SG-Student Awards Agency for Scotland
SG-Transport Scotland
SO-Scotland Office (incl. Office of the Advocate General for Scotland)
UKEF-UK Export Finance
UKSA-Office for National Statistics
UKSA-United Kingdom Statistics Authority
UKSC-UK Supreme Court
WG-Higher Education Funding Council for Wales
WG-Local Democracy and Boundary Commission for Wales
WG-Royal Commission on the Ancient and Historical Monuments of Wales
WG-Welsh Government (excl. agencies)
WG-Welsh Parliament
WG-Welsh Revenue Authority
WO-Wales Office
`);

export const disposalRegionOptions = splitLines(`
East Midlands (England)
East of England
London
Northern Ireland
North East (England)
North West (England)
Scotland
South East (England)
South West (England)
West Midlands (England)
Yorkshire and The Humber
Wales
Overseas
`);

export const disposalAssetTenureOptions = splitLines(`
FH
LH
Mixed Tenure
Other Legal Interest
`);

export const disposalPortfolioTypeOptions = splitLines(`
Courts and Tribunals
Cultural Assets
Defence
Health - Community, Other Health & Social Care
Health - Primary Care & Community
Health - Secondary Care
Infrastructure
Job Centres
Land
Logistics and Storage
Offices
Overseas
Prison
Probation
Remaining Estate
Schools
Science
`);

export const disposalDeriskingOptions = splitLines(`
Significant
Moderate
Minor
Sold
`);

export const disposalForecastYearOptions = splitLines(`
25/26
26/27
27/28
28/29
29/30
`);

export const disposalForecastConfidenceOptions = splitLines(`
Low
Medium
High
Sold
`);

export const disposalMethodOptions = splitLines(`
Private Treaty
Public Auction
Informal Tender
Formal Tender
Negotiated Disposal
JV
Development or Collaboration Agreement
Transfer/ Sale To HE
Transfer/ Sale to OGD
Overage
Clawback
`);

export const disposalYesNoOptions = splitLines(`
Yes
No
`);

export const disposalPurchaserTypeOptions = splitLines(`
Housebuilder
Property developer/ investor
Local Authority
Other organisation or company
Private individual
Transfer/ Sale to HE or OGD
`);

export const disposalBarrierOptions = splitLines(`
Operational strategy/ requirements
Planning
Funding/ affordability
Policy/ legislative
Internal capacity or capability
Other
`);
